// extracted by mini-css-extract-plugin
export default {"dot":"TutorialBeacon-module__dot--DxyE2","pulse":"TutorialBeacon-module__pulse--jC+Lq","bounceIn":"TutorialBeacon-module__bounceIn--K-pMf"};